/**
 * Shared Menu Config / Communications & Help / Admin Tools groups.
 * Used by classic Materio nav (`vertical/index`) and BHYBE rail (`bhyvePrimaryNavItems`)
 * so the two shells cannot drift.
 */

import type { NavGroup } from 'src/@core/layouts/types'
import { ROUTES } from '@/src/utils/routes'
import { GYG_NAV_LABELS } from '@/src/gyg-navigation/navLabels'

export type SplitAdminNavOptions = {
  includeBhyveAdminRailVariant?: boolean
}

export function getSplitAdminNavGroups(options: SplitAdminNavOptions = {}): NavGroup[] {
  const { includeBhyveAdminRailVariant = false } = options

  return [
    {
      title: GYG_NAV_LABELS.menuConfig,
      icon: 'tabler:chef-hat',
      children: [
        {
          title: GYG_NAV_LABELS.restaurantEquipment,
          path: ROUTES.MENU_EQUIPMENTS,
          icon: 'tabler:chef-hat',
          subject: 'admin-tools.menu-equipment',
          action: 'manage'
        },
        {
          title: GYG_NAV_LABELS.restaurantPlus,
          path: ROUTES.ADMIN_TOOLS_INGREDIENTS,
          icon: 'tabler:carrot',
          subject: 'admin-tools.ingredients',
          action: 'manage'
        }
      ]
    },
    {
      title: GYG_NAV_LABELS.communicationsAndHelp,
      icon: 'tabler:speakerphone',
      children: [
        {
          title: 'Announcements',
          path: ROUTES.ANNOUNCEMENTS,
          icon: 'tabler:speakerphone',
          subject: 'admin-tools.announcements',
          action: 'manage'
        },
        {
          title: GYG_NAV_LABELS.howToGuides,
          path: ROUTES.FAQ,
          icon: 'ic:outline-quiz',
          subject: 'faq',
          action: 'read'
        }
      ]
    },
    {
      title: GYG_NAV_LABELS.adminTools,
      icon: 'tabler:tools',
      ...(includeBhyveAdminRailVariant ? { bhyveRailVariant: 'admin-tools' as const } : {}),
      children: [
        {
          title: 'Cron Jobs',
          path: ROUTES.CRON_JOBS,
          icon: 'tabler:clock-cog',
          subject: 'admin-tools.cronjobs',
          action: 'manage'
        },
        {
          title: 'Feature Experiences',
          path: ROUTES.ADMIN_FEATURE_EXPERIENCES,
          icon: 'mdi:flag-variant-outline',
          subject: 'admin-tools.feature-experiences',
          action: 'read'
        },
        {
          title: GYG_NAV_LABELS.emailAuditLog,
          path: ROUTES.EMAIL_AUDIT_LOG,
          icon: 'mdi:email-search-outline',
          subject: 'email-audit-log',
          action: 'read'
        },
        {
          title: 'Role Impersonation',
          path: ROUTES.ADMIN_ROLE_IMPERSONATION,
          icon: 'mdi:account-switch-outline',
          customPermissionCheck: (user: { role?: { id?: number } }) => user?.role?.id === 1
        }
      ]
    }
  ]
}
